export const SIGN_IN_PATH = "/login";
